// export const domain = "http://localhost:3000";
export const domain = "https://traaax.live";
